<template>
  <div>
    <b-row>
      <b-col cols="6">
        <b-card header="Predictive Risk Indicators (PRITM)" style="height: 390px;">
          <b-row>
            <b-col cols="10">
              <p>Entity (inc. Sanctions)</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="warning" text="A"></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Bribery & Corruption</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="success" text="G"></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Human Rights</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="warning" text="A"></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Labour</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="light" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Environmental</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="danger" text="R"></b-avatar>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header="Due Diligence Results" style="height: 390px;">
          <b-row>
            <b-col cols="10">
              <p>Instant Due Diligence (S&E)</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="success" text="G"></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Instant Due Diligence PLUS</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="light" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Enhanced Due Diligence</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="success" text="G"></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Exec Summary Analysis</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="success" text="G"></b-avatar>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="6">
        <b-card header="Questionnaire & Policy Attestation Status" style="height: 390px;">
          <b-row>
            <b-col cols="10">
              <p>Due Diligence Questionnaire</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="warning" icon="people-fill"></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Modern Slavery Questionnaire</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="warning" icon="check"></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Code of Conduct Attestation</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="light" text=" "></b-avatar>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col cols="10">
              <p>Anti-Corruption Policy</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="light" text=" "></b-avatar>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6">
        <b-card header="Training Status" style="height: 390px;">
          <b-row>
            <b-col cols="10">
              <p>Anti-Bribery & Corruption</p>
            </b-col>
            <b-col cols="2">
              <b-avatar variant="light" text=" "></b-avatar>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "RiskOverviewComponent",
  data() {
    return {};
  }
};
</script>